/**
 * ============================================================================
 *  CinematicHero — thin wrapper that renders the reusable EnterpriseHero3D.
 * ============================================================================
 *  The real Three.js / React-Three-Fiber implementation lives in
 *  ./earth/EnterpriseHero3D.jsx. This file exists purely so existing imports
 *  (`@/components/marketing/CinematicHero`) keep working unchanged.
 * ============================================================================
 */
import EnterpriseHero3D from "./earth/EnterpriseHero3D";

export default function CinematicHero(props) {
  return <EnterpriseHero3D {...props} />;
}
